<template>
    <div>
        <h4 class="fw-bold mt-4 mb-3">{{ $t('productos.productos') }}</h4>
        <ul v-for="(producto, index) in productos" :key="producto.item.id" class="resumen d-md-flex">
            <li class="altcolor-content redondeado-izquierda">
                <div class="text-bold oswald text-uppercase m-0 w-100">
                    {{ index + 1 }}. {{ producto.item.name }}
                </div>
            </li>
            <li>
                <div class="h5 text-bold oswald text-uppercase m-0 w-100">
                    {{ $t('resumen_productos.cantidad') }}: {{ producto.units }}
                </div>
            </li>
            <li>
                <label class="h5">{{ $t('resumen_productos.precio_ut') }}</label>
                <div class="h4 mb-1">
                    {{ producto.item.price.toFixed(2) | formatear_precio }} 
                </div>
            </li>
            <li class="redondeado-derecha">
                <label class="h5 ">{{ $t('resumen_productos.precio_total') }}</label>
                <div class="h4 mb-1">
                    {{ (producto.item.price * producto.units) + (producto.item.price_management_interno === 1 ? 0 : (Number(producto.item.price_management)) * producto.units) | formatear_precio }}
                </div>
            </li>
        </ul>
    </div>
</template>
  
<script>
    export default {
        props: {
            productos: {
                type: Array,
                required: true
            }
        },
    }
</script>
<style scoped>
.redondeado-izquierda {
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
}

.redondeado-derecha {
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
}
</style>